type GoogleSignInButtonProps = {
  isLoading: boolean;
  onClick: () => void;
};

/**
 * Filmeel管理画面と同じGoogleサインインボタン
 *
 * @param props - ボタン表示設定
 * @param props.isLoading - Googleへの接続中かどうか
 * @param props.onClick - ボタン押下時の処理
 * @returns Googleサインインボタン
 */
export const GoogleSignInButton = ({ isLoading, onClick }: GoogleSignInButtonProps) => {
  return (
    <button
      aria-busy={isLoading}
      aria-label="Googleでサインイン"
      className="google-sign-in-button"
      disabled={isLoading}
      onClick={onClick}
      type="button"
    >
      <img alt="" className="google-sign-in-button__image" src="/auth/google-signin-light.svg" />
    </button>
  );
};
